import { useContext } from "react";
import { ROType } from "../../../../types/enums";
import { Buffer } from 'buffer';
import { apiGetWorksheet } from "../api/get-worksheet";
import { RetailOrderContext } from "../context/RetailOrderContext";
import { showErrorMessage } from "../../../../utils/messages";
import { WorksheetType } from "../types/WorksheetType";
import { saveAs } from "file-saver";


export default function WorksheetTemplateLink(props: { worksheetType: WorksheetType, caption: string }) {

	const { order } = useContext(RetailOrderContext);

	return (<>
		{
			(order.details.roTypeID === ROType.CabinetMeasureOrder || order.details.roTypeID === ROType.CabinetInstallOrder) &&
			<div className="document-link">
				<a href=""
					onClick={(e) => {
						e.preventDefault();

						apiGetWorksheet(order.details.retailOrderID, props.worksheetType)
							.then((result) => {

								if (result.isSuccess) {
									const file = new Blob(
										[Buffer.from(result.fileContent!, "base64")],
										{ type: 'application/pdf' });

									saveAs.saveAs(file, result.fileName);
								}
								else {
									showErrorMessage(result.errorMessage!);
								}
							});
					}}
				>
					<i className="dx-icon dx-icon-download" />
					{props.caption}
				</a>
			</div>
		}
	</>
	)
} 
